/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-useless-escape */
import React, { Component } from "react";
import * as authServices from "../../services/authService";
import { connect } from "react-redux";

let captchaCheckInterval = null;
class CaptchaComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      requestId: null,
      captchaImage: '',
      solution: '',
      expiryCaptcha: 0
    };
  }
  componentDidMount() {
    this.getCaptchaFn();
    // this.setState({captchaImage: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABkCAAAAADm7SDXAAAAIGNIUk0AAHomAACAhAAA+gAAAIDoAAB1MAAA6mAAADqYAAAXcJy6UTwAAAACYktHRAD/h4/MvwAAAAd0SU1FB+gCAgsUHNDwzF8AAAM6SURBVHja7ZpLSFRhFMf/d7y+YsoGGwkKeilSQYqRFWKZZQUtAh8pLZIwkpAyqk2Yi2gjlIukjIi0bFdmUlQY6CafmOXGatFr0cNqYAiZLK/jaTGOM3cYx3svDB3q/Fb3ft85536/797vMItRCP8Gtr+9ABEREeaICDdEhBsiwg0R4YaIcENEuCEi3BARbogIN0SEGyLCDRHhhohw4/8VeV6ckrDq+CgAnFFmOBQxJzMQ2D5H+fZdyXFLSgcsmJA5HqlwZNqR/IKIagJVjkVMyggEPolcvgpIWhsPW4PJZRGZFPnswGmNxkqR5iXyfPdxDstcEbPc04FbUBa5fAuUei95jkB5GmWReuQQEXmS0DkzNpJoC3nsjcqBcMkXsfxH5PLrUElERDtRFGWRy3nXiIgoG9f9Q1PrcTQkqhy3wuS+TUBH5OouYJCIiJqRFmWRaX4vQpf/uhnO0H0OL1KEwqC7ysC52eofmxhq8xIRUQsyzS5JtdLq3NWurLzp6581qF1gJKn7bkzdHCGxWVkAgMlG7Ih21yKiKwV25H7y312Cczw0Iuwb2a0/6V5thsmQyMkyOL+YXZUFkXwAOf6vfSodZ4MnHwTt0VjwxGsFQ8bqTxRifp/pVVkQ+TD+6jBi7vluHiNR13pnFanCNoP1K7Cw3/yqrB12qsBK3wdRHtIopzRN0w7gpqZpWvC4NwXNusBwh52IiHoQH7Z5z4HF31qn8O49AHgfokQ3oaiqqiqwqaqq6yN932L3Givdiv3ZFlZkUsQ96AEApAKjANDrSthjKPE+tjt0A42Bw96pm3iDXAseMNl+14zeKQaAj8BiAOjGZruhxG4UhOzgbFu4IW61FRGTbyQfVwEADUhLBYBn2GgozztsMBCobd1kRcTkYR+OwYlfpNUpaCMiohW4bShvBPAYfETT+S6DkTrMdq0mFfYMB2wXfLdxMNZhOuA0+oR0VFsRMdu1DvaXzHsZv6/3JADAPYGlhtK+GoyzjiL/oGOGiHBDRLghItwQEW6ICDdEhBsiwg0R4YaIcENEuCEi3BARbogIN0SEGyLCDRHhhohwQ0S4ISLcEBFuiAg3RIQbIsINEeHGH8Nk+em/q75iAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDI0LTAyLTAyVDExOjIwOjI3KzAwOjAwPF5uoQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyNC0wMi0wMlQxMToyMDoyNyswMDowME0D1h0AAAAodEVYdGRhdGU6dGltZXN0YW1wADIwMjQtMDItMDJUMTE6MjA6MjcrMDA6MDAaFvfCAAAAAElFTkSuQmCC"});
  }
  componentWillUnmount() {
    clearInterval(captchaCheckInterval);
  }
  clean(obj) {
    for (var propName in obj) {
      if (obj[propName] === undefined) {
        delete obj[propName];
      }
    }
    return obj;
  }

  onChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value }, () => {
      this.updateParent();
    });
  }

  getCaptchaFn() {
    const self = this;
    this.setState({ loader: true }, () => {
      authServices.getCaptcha().then(async (result) => {
        // self.setState({buttonLoader: false});
        if (!!result && result.captchaImage) {
          this.setState({
            loader: false,
            requestId: result.requestId,
            captchaImage: "data:image/png;base64," + result.captchaImage,
            expiryCaptcha: result.expireTime * 1000,
            solution: ''
          }, () => {
            this.updateParent();
            // this.setCaptchaInterval();
          })
        } else {
          self.setState({ loader: false });
          // self.props.notify(result.exception.message, "error");
        }
      });
    });
  }

  setCaptchaInterval() {
    captchaCheckInterval = setInterval(async function captchaCheckIntervalFn() {
      clearInterval(captchaCheckInterval);

      if (new Date().getTime() < this.state.expiryCaptcha) {
        captchaCheckInterval = setInterval(captchaCheckIntervalFn, 1000);
      } else {
        this.getCaptchaFn();
      }
    }, 1000)
  }

  updateParent() {
    this.props.updateCaptchaData(this.state.requestId, this.state.solution, this.state.expiryCaptcha);
  }

  render() {
    return (
      <>

        <div className="align-items-md-center d-flex mt-3 w-100">
          <div className="captchabox">
            <div className="captchabox-6 mr-1">
              <img src={this.state.captchaImage} alt="" className="captcha_img" />
            </div>
            <div className="captchabox-6-1 captcha-ref-box">
              <input
                className="field p-relative form-control form-font-small"
                type="text"
                value={this.state.solution}
                name="solution"
                id="solution"
                onChange={(e) => {
                  this.onChange(e);
                }}
                placeholder="Solve captcha"
              />
              <i id="iCaptchaRefresh" className="fa fa-refresh ml-1 text-success" onClick={() => this.getCaptchaFn()}></i>
            </div>
          </div>

        </div>
      </>
    );
  }
}
function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(CaptchaComp);
